import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipo-flujo-efectivo-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;
}